import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState, NO_SCROLL } from 'src/app';
import { CashService } from '@services/cash.service';

@Component({
  selector: 'hb-not-funded-modal',
  templateUrl: './not-funded-modal.component.html',
  styleUrls: ['./not-funded-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotFundedModalComponent implements OnInit, OnDestroy {
  @Output() public closeModal = new EventEmitter<void>();

  public clabe$: Observable<string>;

  constructor(
    private readonly cashService: CashService,
    private readonly store: Store<AppState>,
  ) {
    this.clabe$ = this.cashService.getCurrentClabe$();
  }

  ngOnInit() {
    this.toggleScrollBlock(true);
  }

  ngOnDestroy() {
    this.toggleScrollBlock(false);
  }

  private toggleScrollBlock(block: boolean) {
    this.store.dispatch({
      type: NO_SCROLL,
      payload: {
        block,
        source: 'NotFundedModalComponent',
      },
    });
  }
}
